import React, {useState} from "react"
import Modal from "../../components/My/Modal";
import {Button} from "../../components/My/Button";
import InputField from "../../FinalForm/InputField";
import {Form} from "react-final-form";
import {apiCreateEvent} from "./Actions";
import Widget from "../../components/widget";
import Toast from "cogo-toast";
import DateTimeField from "../../FinalForm/DateTimeField";


const ArenaEventsModal = ({visible, close, subjectId}) => {

    let submit
    let [loading, setLoading] = useState(false)

    if (!visible) return null

    const submitForm = (values) => {
        values.subjectId = subjectId
        setLoading(true)
        apiCreateEvent((values), (data) => {
            setLoading(false)
            Toast.success("Údálost byla úspěšně vytvořena.")
            close(true)
        }, error => {
            Toast.warn(error?.message)
            setLoading(false)
        })

    }

    const validate = (values) => {
        let errors = {};
        if (values?.ticketCount) {
            if (Number(values.ticketCount) < 1) {
                errors.ticketCountNumber = true
            }
        }
        return errors;
    }

    return (
        <>
            <Modal title={"Vytvořit událost"}
                   body={
                       <Form
                           validate={validate}
                           onSubmit={submitForm}
                           render={({handleSubmit, errors}) => {
                               submit = handleSubmit
                               return (
                                   <>
                                       <InputField label={"Název události"} name={"eventName"} isMandatory={true}/>
                                       <DateTimeField label={"Datum události"} name={"eventDate"} isMandatory={true}/>
                                       <InputField label={"Počet vstupenek"} name={"ticketCount"} inputType={"number"}
                                                   min={1} isMandatory={true}/>
                                       {errors?.ticketCountNumber &&
                                           <Widget><span className={"text-red-400"}>Musí být alespoň 1 vstupenka.</span></Widget>}
                                   </>
                               )
                           }}/>
                   }
                   visible={visible}
                   close={() => close()}
                   footer={<>
                       <Button text={"Vytvořit událost"} onClick={() => submit()} loading={loading}/>
                   </>
                   }
            />
        </>
    )
}

export default ArenaEventsModal
